<mat-radio-group [class.horizontal-align]="horizontalAlign"
                 [formControl]="formControl"
                 (change)="onOptionChange($event)">
  <mat-radio-button *ngFor="let option of options"
                    [value]="option.value">{{ option.label | translate }}</mat-radio-button>
</mat-radio-group>

<app-form-error-list *ngIf="showErrors"
                     [errorMap]="formControl.errors">
</app-form-error-list>
